import { Button } from "@shapr3d/frontend-lib";

import useNavigation from "../../hooks/navigation";
import useAccount from "../../hooks/useAccount";
import useTranslation from "../../hooks/useTranslation";
import Heading from "../Heading/Heading";

import style from "./ConfirmationEduRequest.module.css";

export const ConfirmationSection = ({
  title,
  text,
  note,
}: {
  title: string;
  text?: React.ReactNode;
  note?: React.ReactNode;
}) => {
  const { goToProfile } = useNavigation();
  const { t, m } = useTranslation();
  return (
    <section>
      <div className={style.container}>
        <Heading type="h1" className={style.title}>
          {title}
        </Heading>
        {text && <p>{text}</p>}
        <Button
          className={style.button}
          onClick={() => {
            goToProfile(["status"]);
          }}
        >
          {t(m.Edu.BackToMyProfile)}
        </Button>
        {note && <div className={style.disclaimer}>{note}</div>}
      </div>
    </section>
  );
};

export enum EduConfirmationStatus {
  Requested = "requested",
  Approved = "approved",
  AlreadyRequested = "already-requested",
  AlreadyEdu = "already-edu",
  VerificationNeeded = "verification-needed",
}

interface ConfirmationEduRequestProps {
  status: EduConfirmationStatus;
}

export const ConfirmationEduRequest: React.FC<ConfirmationEduRequestProps> = ({ status }) => {
  const { data } = useAccount();
  const { t, m } = useTranslation();

  const requestedText = t(m.Edu.RequestedText);
  switch (status) {
    case EduConfirmationStatus.Requested: {
      return <ConfirmationSection title={t(m.Edu.TitleRequested)} text={requestedText} />;
    }
    case EduConfirmationStatus.Approved: {
      return (
        <ConfirmationSection
          title={t(m.Edu.TitleApproved)}
          note={t(m.Edu.ApprovedNote, {
            strong: (chunks) => <strong>{chunks}</strong>,
          })}
        />
      );
    }
    case EduConfirmationStatus.AlreadyRequested: {
      return <ConfirmationSection title={t(m.Edu.TitleAlreadyRequested)} text={requestedText} />;
    }
    case EduConfirmationStatus.AlreadyEdu: {
      return <ConfirmationSection title={t(m.Edu.TitleAlreadyEdu)} />;
    }
    case EduConfirmationStatus.VerificationNeeded: {
      return (
        <ConfirmationSection
          title={t(m.Edu.TitleVerifyEmail)}
          text={t(m.Edu.VerifyEmailText, { email: data?.email })}
        />
      );
    }
    default: {
      return <ConfirmationSection title={t(m.Edu.TitleError)} />;
    }
  }
};
